import { useState } from "react";

interface IFormInput {
	initialFValues: any;
	validateOnChange: boolean; // Default false, set tru if you want to validate the form on change.
	validate: any; // Used to validate the form fields. component specific.
}

interface IFormOutPut {
	values: any;
	setValues: any;
	errors: any;
	setErrors: any;
	handleInputChange?: any;
	resetForm?: any;
}

/**
 * useForm => Custom Hooks
 * Input / Params => IFormInput
 * OutPut => IFormOutPut
 */

export function useForm(props: IFormInput) {
	const { initialFValues, validateOnChange, validate } = props;

	const [values, setValues] = useState<any>(initialFValues);
	const [errors, setErrors] = useState<any>({});

	const handleInputChange = (e: any) => {
		const { name, value } = e.target;
		setValues({ ...values, [name]: value });
		if (validateOnChange) validate({ [name]: value });
	};

	const resetForm = () => {
		setValues(initialFValues);
		setErrors({});
	};

	const result: IFormOutPut = {
		values,
		setValues,
		errors,
		setErrors,
		handleInputChange,
		resetForm,
	};
	return result;
}

export function Form(props: any) {
	const { children, ...other } = props;
	return (
		<form autoComplete="off" {...other}>
			{props.children}
		</form>
	);
}
